let constEditor: any = {
  editorRef: null,
  editorInitValueRef: null,
};

const setEditorData = (key, val) => {
  constEditor[key] = val;
};

const getEditorData = (key) => {
  return constEditor[key];
};

const destroyEditorData = () => {
  constEditor = {};
};
export { setEditorData, getEditorData, destroyEditorData };
